// components/TerminalEntry.jsx
import useFadeInOnScroll from '../hooks/useFadeInOnScroll.js';

const TerminalEntry = ({ entry }) => {
  const { ref, isVisible } = useFadeInOnScroll();

  return (
    <div
      ref={ref}
      className={`terminal-entry fade-section ${isVisible ? 'visible' : ''}`}
    >
      <p>
        <span className="prompt">~$ </span>
        {entry.command}
      </p>
      <div className="terminal-output">{entry.output}</div>
    </div>
  );
};

export default TerminalEntry;
